let mainImages = document.getElementsByClassName('mainProductImage')
let thumbs = document.getElementsByClassName('productImage')
let dataImgs = document.querySelectorAll('[data-image]')

Array.from(thumbs).forEach(thumb => {
  thumb.addEventListener('click', (event) => changeImg(event))
})

function changeImg(event) {
  let newImg = event.target.getAttribute('data-image')
  let actives = document.getElementsByClassName('activeMainImage')
  let activeThumbs = document.getElementsByClassName('activeThumb')

  Array.from(actives).forEach(a => a.classList.remove('activeMainImage'))
  Array.from(activeThumbs).forEach(a => a.classList.remove('activeThumb'))

  Array.from(mainImages).forEach((img, i) => {
    !img.classList.contains('activeMainImage') && img.getAttribute('data-image') == newImg ? img.classList.add('activeMainImage') : null
    !img.classList.contains('activeMainImage') && img.getAttribute('data-image') !== newImg ? img.classList.remove('activeMainImage') : null
  })

  Array.from(thumbs).forEach((img, i) => {
    img.getAttribute('data-image') == newImg ? img.classList.add('activeThumb') : null
  })
}


const productImage = document.getElementById('mainProductImageContainer')
productImage ? productImage.addEventListener('click', (event) => imageModule(event)) : null

function imageModule(event) {
  let activeImg = document.getElementsByClassName('activeMainImage')
  let imgIdent = activeImg[0].getAttribute('data-image')
  let modalImgs = document.getElementsByClassName('modalImg')
  
  Array.from(modalImgs).forEach((img, i) => {
    img.classList.contains('activeModalImg') ? img.classList.remove('activeModalImg') : null
    if(parseInt(img.getAttribute('data-image')) == parseInt(imgIdent)) {
      img.classList.add('activeModalImg')
    }
  })
  
  document.getElementsByClassName('activeModalImg')[0].addEventListener('click', (event) => modalEvent())
}

function modalEvent() {
  document.getElementsByClassName('activeModalImg')[0] ? document.getElementsByClassName('activeModalImg')[0].classList.remove('activeModalImg') : null
}